import { ContactBook } from '@/plugins/api'

export default {
  namespaced: true,
  state: {},
  actions: {
    async sendMarkNotification({ commit }, params) {
      await ContactBook.sendMarkNotification(params)
    },
    async sendDailyViolation({ commit }, params) {
      await ContactBook.sendDailyViolation(params)
    },
    async sendTuitionFeePeriodNoti({ commit }, params) {
      await ContactBook.sendTuitionFeePeriodNoti(params)
    },
    async sendTuitionFeePeriod({ commit }, params) {
      let res = await ContactBook.sendTuitionFeePeriod(params)
      return res
    },
    async getProgressTuitionFeePeriod({ commit }, params) {
      let res = await ContactBook.getProgressTuitionFeePeriod(params)
      return res
    },
  },
  mutations: {},
  getters: {}
}
